import styled from "styled-components";
import React from "react";
import { PodSettings } from "../../assets/Podcast/PodSettings";
import { PodAnalytics } from "../../assets/Podcast/PodAnalytics";
import { PodFolder } from "../../assets/Podcast/PodFolder";
import { PodExam } from "../../assets/Podcast/PodExam";
import { gql, useQuery } from "@apollo/client";
import { Loading } from "../../components/Loading";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const StyleCss = styled.div`
  .campaign {
    margin: 7.5px;
    padding: 5px 10px;
    border: 1px solid var(--n-grey-3);
    background-color: var(--n-grey-1);
    border-radius: 8px;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-decoration: none;
    color: var(--n-text-2);
    transition: all 0.15s ease-in-out;
    :hover {
      border: 1px solid var(--n-grey-7);
      color: var(--n-text-1);
    }
    &.header {
      border: none;
      background-color: transparent;
      margin: 7.5px 7.5px 0;
      font-weight: 500;
      .column {
        padding: 0.5rem 0.5rem 0;

      }
    }
    .column {
      padding: 0.5rem;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    .contract {
      padding: 0.7rem 1rem;
      display: flex;
      box-shadow: 0px 4px 8px -2px #00000040;
      border-radius: 4px;
      text-decoration: none;
      color: inherit;
      transition: all 0.2s ease-in-out;
      :hover {
        background-color: #00000010;
      }
      .expand {
        flex-grow: 1;
      }
      .date {
        width: 25%;
      }
      .more-info {
        color: blue;
        cursor: pointer;
      }
      &.header {
        font-weight: 700;
        :hover {
          background-color: inherit;
        }
      }
    }
  }
`;
export const Exams_Query = gql`
  query ExamsQuery{
    getAllExamsForUser{
        _id
        Title
        Description
        StartDate
        TotalScore
        PassScore
    }
  }
`
function WorkPageExams(props) {
  const exams = useQuery(Exams_Query, {
    fetchPolicy: "network-only"
  });
  if(exams.loading){
    return (
      <StyleCss className="main-box">
        <div className="title-bar">
          <div className="title">
            <div className="icon"><PodExam/></div>
            <div className="text">Exams</div>
          </div>
        </div>
        <div className="content">
          <Loading/>
        </div>
      </StyleCss>
    )
  }
  const makeTable = () => {
    let data = []
    if(exams.data.getAllExamsForUser){
      data = exams.data.getAllExamsForUser
    }
    return data.map((v, i) => {
      return (
        <Link to={"/work/exams/"+v._id} className="contract" key={i}>
          <div className="date">{v.Title}</div>
          <div className="date"></div>
          <div className="expand"></div>
          <div className="more-info">
              more info
          </div>
        </Link>
      )
    })
  }
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
            <div className="icon"><PodExam/></div>
            <div className="text">Exams</div>
          </div>
      </div>
      <div className="content">
        <div className="contract header">
          <div className="date">name</div>
          <div className="date"></div>
          <div className="more-info"></div>
        </div>
        {makeTable()}
        {/* <div className="contract">
          <div className="date">1402/02/01</div>
          <div className="date">1402/06/01</div>
          <div className="expand"></div>
          <div className="more-info"></div>
        </div> */}
      </div>
    </StyleCss>
  )
}
export default WorkPageExams;